import { Component, Input, Renderer2, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'ng-expandable-area',
  template: `<div class="ep-collapse-title" (click)="showArea()">
  {{ title }}
  <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h
  0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT
  0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iIzY0NTM5NCIgZmlsbC1ydWxlPSJub256Z
  XJvIiBkPSJNMTUuODg0IDkuMjk0TDEyIDEzLjE3IDguMTE2IDkuMjk0YS45OTcuOTk3IDAgMSAw
  LTEuNDEgMS40MWw0LjU4NyA0LjU4OWExIDEgMCAwIDAgMS40MTQgMGw0LjU4OC00LjU4OGEuOTk
  4Ljk5OCAwIDAgMC0xLjQxLTEuNDF6Ii8+CiAgICAgICAgPHBhdGggZD0iTTAgMGgyNHYyNEgwei
  IvPgogICAgPC9nPgo8L3N2Zz4K">
</div>
<div class="ep-collapse-area">
  <ng-content></ng-content>
</div>
`,
  styles: [`.ep-collapse-title{opacity:.9;font-size:1em;font-weight:700;line-height:1.33;text-align:left;color:#000;text-transform:uppercase;position:relative;padding-right:28px;margin:15px 0}.ep-collapse-title:hover{cursor:pointer}.ep-collapse-title img{position:absolute;width:24px;height:24px;right:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.ep-collapse-area{margin:15px 0;display:none}.ep-collapse-area.active{display:block}:host.active .ep-collapse-area{display:block}:host.active .ep-collapse-title img{-webkit-transform:rotate(0);transform:rotate(0)}`]
})
export class ExpandableAreaComponent implements OnInit {
  @Input() public title: string;
  @Input() public opened: boolean;

  constructor(
    private _elementRef: ElementRef,
    private renderer: Renderer2
  ) { }

  public ngOnInit(): void {
    if (this.opened) {
      this.show();
    }
  }

  public showArea() {
    if (this._elementRef.nativeElement.classList.contains('active')) {
      this.hide();
    } else {
      this.show();
    }
  }

  private show() {
    this.renderer.addClass(this._elementRef.nativeElement, 'active');
  }

  private hide() {
    this.renderer.removeClass(this._elementRef.nativeElement, 'active');
  }

}
